// useCreateOtp.js
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchAsyncCreatePaymentOtp } from 'redux/paymentSlice';
import prJson from "components/jsonData/purchase.json";
import { useToasts } from "react-toast-notifications";
import { validateAmount, validateCreateOtpField } from '../validations';
import ConfirmationDialog from 'components/sweetAlert.js/ConfirmationDialog';

const useCreateOtp = (senderData, reciverData, requestedAmount, method, limits) => {
  const dispatch = useDispatch();
  const {addToast} = useToasts();
  const [isOtpLoading, setIsOtpLoading] = useState(false);
  const [otpIsSuccess, setOtpIsSuccess] = useState(false);

  const fetchCreateOtpApi = async (data) => {
    setIsOtpLoading(true);
    try {
      const res = await dispatch(fetchAsyncCreatePaymentOtp({ data }));
      if (res?.payload && res?.payload?.data) {
        setOtpIsSuccess(true);
        addToast(prJson.success.otp, { appearance: "success" });
      } else {
        addToast(`${res?.error?.message}`, { appearance: "error" });
      }
    } catch (error) {
      addToast(`error`, { appearance: "error" });
    } finally {
      setIsOtpLoading(false);
    }
  };

  const handleProcedBtn = () => {
    const data = {
      aggrId: senderData?.aggrId,
      aggrName: senderData?.aggrName,
      corpId: senderData?.corpId,
      userId: senderData?.userId,
      urn: senderData?.urn,
      uniqueId: reciverData?.uniqueId,
      amount: requestedAmount,
      method: method,
    };

    const validationAmount = validateAmount(requestedAmount, limits);
    if (!validationAmount.isValid) {
      addToast(validationAmount.message, { appearance: "error" });
      return;
    }

    const validationResult = validateCreateOtpField(data);
    if (!validationResult.isValid) {
      addToast(validationResult.message, { appearance: "error" });
      return;
    }

    ConfirmationDialog({
      title: "Confirm Payment",
      text: `Please check all details carefully before you proceed.`,
      icon: "warning",
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        fetchCreateOtpApi(data);
      },
    });
  };

  return {
    isOtpLoading,
    otpIsSuccess,
    handleProcedBtn,
    setOtpIsSuccess
  };
};

export default useCreateOtp;
